export const molds = [
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1000,
    dimensions: '280mm x 200mm x h40mm',
    id: 0,
    title: 'SFT203 CHRISTMAS TREE',
    url: 'https://shop.silikomart.com/en/moulds/sft203-christmas-tree-stampo-in-silicone-280x200-h-40-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 23,
    dimensions: '27mm, \u00d844mm',
    id: 1,
    title: 'SF072 SMALL SUNFLOWER',
    url: 'https://shop.silikomart.com/en/moulds/sf072-small-sunflower-stampo-in-silicone-o44-h-27mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 460,
    dimensions: '188mm x 158mm x h26mm',
    id: 2,
    title: 'KIT TARTE MON AMOUR',
    url: 'https://shop.silikomart.com/en/kit-tarte-mon-amour-set-anello-cuore-stampo-in-silicone-o220-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 31,
    dimensions: '65mm x 55mm x h15mm',
    id: 3,
    title: 'KIT MINI TARTE PETIT AMOUR',
    url: 'https://shop.silikomart.com/en/kit-mini-tarte-petit-amour-stampo-in-silicone-8-anelli-cuore',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 560,
    dimensions: '180mm x 180mm x h19mm',
    id: 4,
    title: 'Kit Tarte Liberty',
    url: 'https://shop.silikomart.com/en/kit-tarte-liberty-set-anello-tappeto-decorativo-in-silicone-200x200-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 380,
    dimensions: '250mm x 90mm x h20mm',
    id: 5,
    title: 'Kit Tarte Bamboo',
    url: 'https://shop.silikomart.com/en/kit-tarte-bamboo',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 290,
    dimensions: '240mm x 80mm x h24mm',
    id: 6,
    title: 'Kit Tarte Nouvelle Vague',
    url: 'https://shop.silikomart.com/en/kit-tarte-nouvelle-vague',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 710,
    dimensions: '285mm x 320mm x h20mm, \u00d8230mm',
    id: 7,
    title: 'Kit Tarte Grafique',
    url: 'https://shop.silikomart.com/en/kit-tarte-graphique',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 480,
    dimensions: '20mm, \u00d8250mm',
    id: 8,
    title: 'Kit Tarte Meringu\u00e9',
    url: 'https://shop.silikomart.com/en/kit-tarte-meringue',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 45,
    dimensions: '67mm x 67mm x h15mm',
    id: 9,
    title: 'Kit Mini Tarte Sand',
    url: 'https://shop.silikomart.com/en/kit-mini-tarte-sand',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 46,
    dimensions: '180mm x 330mm x h18mm, \u00d870mm',
    id: 10,
    title: 'Kit Mini Tarte Glam',
    url: 'https://shop.silikomart.com/en/kit-mini-tarte-glam',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 53,
    dimensions: '25mm, \u00d870mm',
    id: 11,
    title: 'Kit Mini Tarte Twist',
    url: 'https://shop.silikomart.com/en/kit-mini-tarte-twist',
  },
  {
    brand: 'Silikomart',
    cavityCount: 2,
    cavityVolume: 1.6,
    dimensions: '110 mm x 60 mm x h220 mm',
    id: 12,
    title: 'NUVOLA',
    url: 'https://shop.silikomart.com/en/nuvola',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 1.12,
    dimensions: '65mm, \u00d873 mm',
    id: 13,
    title: 'CREAM',
    url: 'https://shop.silikomart.com/en/cream',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1200,
    dimensions: '88x218mm h80mm',
    id: 14,
    title: 'WINTER VILLAGE',
    url: 'https://shop.silikomart.com/en/winter-village-kit-stampi-in-silicone-240x100-h-82-mm-plastic-support',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1400,
    dimensions: '195mm h50mm',
    id: 15,
    title: 'VINILE',
    url: 'https://shop.silikomart.com/en/vinile-stampo-in-silicone-o195-h-50-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1000,
    dimensions: '250x89mm h87mm',
    id: 16,
    title: 'B\u00dbCHE SAPIN',
    url: 'https://shop.silikomart.com/en/buche-sapin-stampo-in-silicone-250x89-h-87-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1000,
    dimensions: '243x90mm h77mm',
    id: 17,
    title: 'B\u00dbCHE QUENELLE',
    url: 'https://shop.silikomart.com/en/buche-quenelle-stampo-in-silicone-245x95-h-77mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1300,
    dimensions: '190 h72mm',
    id: 18,
    title: 'WOOLY',
    url: 'https://shop.silikomart.com/en/wooly-stampo-in-silicone-o190-h70-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1460,
    dimensions: '200 h50mm',
    id: 19,
    title: 'COLOR',
    url: 'https://shop.silikomart.com/en/color-stampo-in-silicone-o200-h-50-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 115,
    dimensions: '73 h30mm',
    id: 20,
    title: 'MINI COLOR',
    url: 'https://shop.silikomart.com/en/mini-color-stampo-in-silicone-n-6-o73-h-30-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 14,
    cavityVolume: 40,
    dimensions: '40 h40mm',
    id: 21,
    title: 'MINI PUFF',
    url: 'https://shop.silikomart.com/en/mini-puff-stampo-in-silicone-n-15-o40-h-40-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1100,
    dimensions: '100mm, \u00d8120mm',
    id: 22,
    title: 'TOWER',
    url: 'https://shop.silikomart.com/en/tower-stampo-in-silicone-o120-h-100-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1200,
    dimensions: '245mm x 95mm x h77mm',
    id: 23,
    title: 'LANA',
    url: 'https://shop.silikomart.com/en/lana-stampo-in-silicone-245x95-h-77-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1400,
    dimensions: '210mm x 210mm x h35mm',
    id: 24,
    title: 'QUADRO',
    url: 'https://shop.silikomart.com/en/quadro-stampo-in-silicone-210x210-h-35-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 2,
    cavityVolume: 910,
    dimensions: '260mm x 100mm x h75mm',
    id: 25,
    title: 'Kit Ice Glow',
    url: 'https://shop.silikomart.com/en/kit-ice-glow',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1100,
    dimensions: '240mm x 100mm x h83mm',
    id: 26,
    title: 'FOR\u00caT',
    url: 'https://shop.silikomart.com/en/foret-kit-stampi-in-silicone-240x100-h82-mm-plastic-support',
  },
  {
    brand: 'Silikomart',
    cavityCount: 2,
    cavityVolume: 500,
    dimensions: '250mm x 92mm x h87mm',
    id: 27,
    title: 'ARTIC',
    url: 'https://shop.silikomart.com/en/artic-stampo-in-silicone-250x92-h-87-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1000,
    dimensions: '60mm, \u00d8160mm',
    id: 28,
    title: 'MOMENTS',
    url: 'https://shop.silikomart.com/en/moments-stampo-in-silicone-o160-h-60-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 125,
    dimensions: '52mm, \u00d862mm',
    id: 29,
    title: 'PUFF',
    url: 'https://shop.silikomart.com/en/puff-stampo-in-silicone-n-8-puff-o62-h-52-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1600,
    dimensions: '70mm, \u00d8195mm',
    id: 30,
    title: 'HONOR\u00c9',
    url: 'https://shop.silikomart.com/en/honore-stampo-in-silicone-o190-h-70-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1500,
    dimensions: '60mm, \u00d8200mm',
    id: 31,
    title: 'DOT',
    url: 'https://shop.silikomart.com/en/dot-stampo-in-silicone-o200-h-58-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 90,
    dimensions: '30mm, \u00d870mm',
    id: 32,
    title: 'MINI DOT',
    url: 'https://shop.silikomart.com/en/mini-dot-stampo-in-silicone-n-6-mini-dot-o70-h-30-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 95,
    dimensions: '80mm x 45mm x h35mm',
    id: 33,
    title: 'SWING',
    url: 'https://shop.silikomart.com/en/swing-stampo-in-silicone-n-6-80x45-h-35-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 100,
    dimensions: '183mm x 338mm x h36mm, \u00d870mm',
    id: 34,
    title: 'Mini Arena',
    url: 'https://shop.silikomart.com/en/mini-arena',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1700,
    dimensions: '241mm x 281mm x h70mm, \u00d8220mm',
    id: 35,
    title: 'Arena',
    url: 'https://shop.silikomart.com/en/arena',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1400,
    dimensions: '245mm x 90mm x h90mm',
    id: 36,
    title: 'Corallo',
    url: 'https://shop.silikomart.com/en/corallo',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 130,
    dimensions: '180mm x 340mm x h55mm, \u00d870mm',
    id: 37,
    title: 'Coccola',
    url: 'https://shop.silikomart.com/en/coccola',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1660,
    dimensions: '240mm x 280mm x h70mm, \u00d8210mm',
    id: 38,
    title: 'Gioia',
    url: 'https://shop.silikomart.com/en/gioia',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1650,
    dimensions: '240mm x 280mm x h70mm, \u00d8210mm',
    id: 39,
    title: 'Intreccio',
    url: 'https://shop.silikomart.com/en/intreccio',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 105,
    dimensions: '182mm x 337mm x h35mm, \u00d875mm',
    id: 40,
    title: 'Mini Intreccio',
    url: 'https://shop.silikomart.com/en/mini-intreccio',
  },
  {
    brand: 'Silikomart',
    cavityCount: 2,
    cavityVolume: 1770,
    dimensions: '240mm x 280mm x h60mm, \u00d8210mm',
    id: 41,
    title: 'Io & Te',
    url: 'https://shop.silikomart.com/en/io-te',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 140,
    dimensions: '130mm x 38mm x h40mm',
    id: 42,
    title: 'Kit Pop Eclair',
    url: 'https://shop.silikomart.com/en/kit-pop-eclair',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 140,
    dimensions: '130mm x 38mm x h44mm',
    id: 43,
    title: 'Kit Chic Eclair',
    url: 'https://shop.silikomart.com/en/kit-chic-eclair',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 120,
    dimensions: '52mm, \u00d862mm',
    id: 44,
    title: 'Dolce Tartufo',
    url: 'https://shop.silikomart.com/en/dolce-tartufo',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 100,
    dimensions: '180mm x 336mm x h70mm, \u00d860mm',
    id: 45,
    title: 'Soffice Incanto',
    url: 'https://shop.silikomart.com/en/soffice-incanto',
  },
  {
    brand: 'Silikomart',
    cavityCount: 9,
    cavityVolume: 105,
    dimensions: '50mm x 50mm x h50mm',
    id: 46,
    title: 'Mosaico',
    url: 'https://shop.silikomart.com/en/mosaico',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1530,
    dimensions: '240mm x 280mm x h68mm, \u00d8195mm',
    id: 47,
    title: 'Raggio',
    url: 'https://shop.silikomart.com/en/raggio',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1510,
    dimensions: '280mm x 120mm x h65mm',
    id: 48,
    title: 'Frutti Rossi',
    url: 'https://shop.silikomart.com/en/frutti-rossi',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 115,
    dimensions: '180mm x 340mm x h55mm, \u00d865mm',
    id: 49,
    title: 'Segreti del Bosco',
    url: 'https://shop.silikomart.com/en/segreti-del-bosco',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 118,
    dimensions: '182mm x 339mm x h52mm, \u00d862mm',
    id: 50,
    title: 'Ispirazioni di Frutta',
    url: 'https://shop.silikomart.com/en/ispirazioni-di-frutta',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 106,
    dimensions: '85mm x 59mm x h42mm',
    id: 51,
    title: 'Delizia al Limone',
    url: 'https://shop.silikomart.com/en/delizia-al-limone',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 95,
    dimensions: '61mm, \u00d859mm',
    id: 52,
    title: 'Fragole e Panna',
    url: 'https://shop.silikomart.com/en/fragole-e-panna',
  },
  {
    brand: 'Silikomart',
    cavityCount: 5,
    cavityVolume: 105,
    dimensions: '58mm x 100mm x h38mm',
    id: 53,
    title: 'Mini Ananas',
    url: 'https://shop.silikomart.com/en/mini-ananas',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1100,
    dimensions: '90mm x 250mm x h75mm',
    id: 54,
    title: 'Meringa',
    url: 'https://shop.silikomart.com/en/meringa',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1670,
    dimensions: '240mm x 280mm x h60mm, \u00d8220mm',
    id: 55,
    title: 'Luna',
    url: 'https://shop.silikomart.com/en/luna',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1650,
    dimensions: '240mm x 280mm x h70mm, \u00d8200mm',
    id: 56,
    title: 'Goccia',
    url: 'https://shop.silikomart.com/en/goccia',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1200,
    dimensions: '250mm x 150mm x h65mm',
    id: 57,
    title: 'Bacio',
    url: 'https://shop.silikomart.com/en/bacio',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1523,
    dimensions: '205mm x 198mm x h62mm',
    id: 58,
    title: 'Batticuore',
    url: 'https://shop.silikomart.com/en/batticuore',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1200,
    dimensions: '80mm x 250mm x h67mm',
    id: 59,
    title: 'Magic Buche',
    url: 'https://shop.silikomart.com/en/magic-buche',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1200,
    dimensions: '80mm x 250mm x h67mm',
    id: 60,
    title: 'Frozen Buche',
    url: 'https://shop.silikomart.com/en/frozen-buche',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1300,
    dimensions: '250mm x 90mm x h70mm',
    id: 61,
    title: 'Diamond Buche',
    url: 'https://shop.silikomart.com/en/diamond-buche',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 100,
    dimensions: '205mm x 198mm x h63mm',
    id: 62,
    title: 'Cuoricino',
    url: 'https://shop.silikomart.com/en/cuoricino',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 100,
    dimensions: '300mm x 175mm x h39mm',
    id: 63,
    title: 'Mini Girotondo',
    url: 'https://shop.silikomart.com/en/mini-girotondo',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 101,
    dimensions: '300mm x 175mm x h32mm',
    id: 64,
    title: 'Mini Eleganza',
    url: 'https://shop.silikomart.com/en/mini-eleganza',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 85,
    dimensions: '181mm x 336mm x h33mm, \u00d867mm',
    id: 65,
    title: 'Mini Raggio',
    url: 'https://shop.silikomart.com/en/mini-raggio',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 88,
    dimensions: '181mm x 336mm x h32mm, \u00d868mm',
    id: 66,
    title: 'Mini Goccia',
    url: 'https://shop.silikomart.com/en/mini-goccia',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1690,
    dimensions: '263mm x 299mm x h65mm, \u00d8220mm',
    id: 67,
    title: 'Abbraccio',
    url: 'https://shop.silikomart.com/en/abbraccio',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1500,
    dimensions: '264mm x 298mm x h50mm, \u00d8220mm',
    id: 68,
    title: 'Primavera',
    url: 'https://shop.silikomart.com/en/primavera',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1700,
    dimensions: '246mm x 282mm x h62mm, \u00d8250mm',
    id: 69,
    title: 'Eleganza',
    url: 'https://shop.silikomart.com/en/eleganza',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1680,
    dimensions: '254mm x 290mm x h60mm, \u00d8252mm',
    id: 70,
    title: 'Girotondo',
    url: 'https://shop.silikomart.com/en/girotondo',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1590,
    dimensions: '90mm, \u00d8180mm',
    id: 71,
    title: 'Gemma',
    url: 'https://shop.silikomart.com/en/gemma',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 8,
    dimensions: '110mm x 240mm x h28mm, \u00d827mm',
    id: 72,
    title: 'Scg47 Choco Flame',
    url: 'https://shop.silikomart.com/en/choco-flame',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 8,
    dimensions: '31mm x 30mm x h15mm',
    id: 73,
    title: 'Scg48 My Love',
    url: 'https://shop.silikomart.com/en/my-love',
  },
  {
    brand: 'Silikomart',
    cavityCount: 11,
    cavityVolume: 9,
    dimensions: '110mm x 240mm x h15mm, \u00d830mm',
    id: 74,
    title: 'Scg49 Choco Crown',
    url: 'https://shop.silikomart.com/en/choco-crown',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 110,
    dimensions: '180mm x 340mm x h43mm, \u00d868mm',
    id: 75,
    title: 'Mini Gemma',
    url: 'https://shop.silikomart.com/en/mini-gemma',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 105,
    dimensions: '75mm x 50mm x h45mm',
    id: 76,
    title: 'Rosso Ciliegia',
    url: 'https://shop.silikomart.com/en/rosso-ciliegia',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1600,
    dimensions: '55mm, \u00d8220mm',
    id: 77,
    title: 'Bolle',
    url: 'https://shop.silikomart.com/en/bolle',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 8,
    dimensions: '112mm x 240mm x h27mm',
    id: 78,
    title: 'Scg50 Tartufino',
    url: 'https://shop.silikomart.com/en/tartufino',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 8,
    dimensions: '112mm x 240mm x h27mm',
    id: 79,
    title: 'Scg51 Choco Game',
    url: 'https://shop.silikomart.com/en/choco-game',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1200,
    dimensions: '80mm x 250mm x h67mm',
    id: 80,
    title: 'Starlight Buche',
    url: 'https://shop.silikomart.com/en/kit-startlight-buche',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 85,
    dimensions: '30mm, \u00d870mm',
    id: 81,
    title: 'Bollicine',
    url: 'https://shop.silikomart.com/en/bollicine',
  },
  {
    brand: 'Silikomart',
    cavityCount: 2,
    cavityVolume: 400,
    dimensions: '220mm x 50mm x h40mm',
    id: 82,
    title: 'Inserto B\u00fbche',
    url: 'https://shop.silikomart.com/en/inserto-buche',
  },
  {
    brand: 'Silikomart',
    cavityCount: 3,
    cavityVolume: 600,
    dimensions: '210mm x 246mm x h25mm, \u00d8176mm',
    id: 83,
    title: 'Multi-Inserto Round',
    url: 'https://shop.silikomart.com/en/multi-inserto-round',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1300,
    dimensions: '296mm x 130mm x h72mm',
    id: 84,
    title: 'KIT MAGIC WOOD - STAMPO IN SILICONE BUCHE+TAPPETO IN SILICONE',
    url: 'https://shop.silikomart.com/en/kit-magic-wood-stampo-in-silicone-buche-tappeto-in-silicone',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1300,
    dimensions: '296mm x 130mm x h72mm',
    id: 85,
    title: 'Kit Magic Love',
    url: 'https://shop.silikomart.com/en/kit-magic-love',
  },
  {
    brand: 'Silikomart',
    cavityCount: 30,
    cavityVolume: 14,
    dimensions: '44mm x 18mm x h20mm',
    id: 86,
    title: 'Sf129 Mini Buche',
    url: 'https://shop.silikomart.com/en/sf129-mini-buche',
  },
  {
    brand: 'Silikomart',
    cavityCount: 24,
    cavityVolume: 14,
    dimensions: '50mm x 18mm x h23mm',
    id: 87,
    title: 'Sf125 Chocogianduia',
    url: 'https://shop.silikomart.com/en/sf-125-chocogianduia',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 2100,
    dimensions: '288mm x 156mm x h83mm',
    id: 88,
    title: 'Treccia',
    url: 'https://shop.silikomart.com/en/treccia',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 40,
    dimensions: '215mm x 107mm x h16mm',
    id: 89,
    title: 'Sf184 My Snack',
    url: 'https://shop.silikomart.com/en/my-snack',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 15,
    dimensions: '40mm x 40mm x h10mm',
    id: 90,
    title: 'Pan01 Happy Snack Square',
    url: 'https://shop.silikomart.com/en/pan-01-happy-snack-square',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 8,
    dimensions: '',
    id: 91,
    title: 'Onda-P',
    url: 'https://shop.silikomart.com/en/ch001-onda-p-stampo-in-tritan-n-24-28-x-28-h-13-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 85,
    dimensions: '',
    id: 92,
    title: 'Onda-T',
    url: 'https://shop.silikomart.com/en/ch002-onda-t-stampo-in-tritan-n-3-150-x-70-h-11-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 26,
    dimensions: '',
    id: 93,
    title: 'Onda-B',
    url: 'https://shop.silikomart.com/en/ch003-onda-b-stampo-in-tritan-n-10-20-x-120-h-15-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 8,
    dimensions: '',
    id: 94,
    title: 'Goccia-P',
    url: 'https://shop.silikomart.com/en/ch007-goccia-p-stampo-in-tritan-n-24-29-x-41-h-14-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 80,
    dimensions: '',
    id: 95,
    title: 'Goccia-T',
    url: 'https://shop.silikomart.com/en/ch008-goccia-t-stampo-in-tritan-n-3-150-x-70-h-8-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 30,
    dimensions: '',
    id: 96,
    title: 'Goccia-B',
    url: 'https://shop.silikomart.com/en/ch009-goccia-b-stampo-in-tritan-n-8-120-x-25-h-16-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 8,
    dimensions: '',
    id: 97,
    title: 'Riga-P',
    url: 'https://shop.silikomart.com/en/ch004-riga-p-stampo-in-tritan-n-24-47-x-15-h-16-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 68,
    dimensions: '',
    id: 98,
    title: 'Riga-T',
    url: 'https://shop.silikomart.com/en/ch005-riga-t-stampo-in-tritan-n-4-150-x-55-h-9-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 25,
    dimensions: '',
    id: 99,
    title: 'Riga-B',
    url: 'https://shop.silikomart.com/en/ch006-riga-b-stampo-in-tritan-n-10-119-x-18-h-17-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 8,
    dimensions: '',
    id: 100,
    title: 'Bolla-P',
    url: 'https://shop.silikomart.com/en/ch010-bolla-p-stampo-in-tritan-n-24-40-x-25-h-14-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 68,
    dimensions: '',
    id: 101,
    title: 'Bolla-T',
    url: 'https://shop.silikomart.com/en/ch011-bolla-t-stampo-in-tritan-n-4-156-x-61-h-14-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 25,
    dimensions: '',
    id: 102,
    title: 'Bolla-B',
    url: 'https://shop.silikomart.com/en/ch012-bolla-b-stampo-in-tritan-n-10-115-x-25-h-15-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 8,
    dimensions: '30mm, \u00d828mm\u230028mm h30mm',
    id: 103,
    title: 'SCG054 CHOCO TREE',
    url: 'https://shop.silikomart.com/en/scg055-3d-choco-trees',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 9,
    dimensions: '',
    id: 104,
    title: 'CHOCO SPIRAL',
    url: 'https://shop.silikomart.com/en/scg52-3d-choco-spiral-stampo-in-silicone-n-15-choco-spiral',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 8,
    dimensions: '',
    id: 105,
    title: 'CHOCO DROP',
    url: 'https://shop.silikomart.com/en/scg53-3d-choco-drop-stampo-in-silicone-n-15-choco-drop',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 8,
    dimensions: '35mm x 32mm x h16mm',
    id: 106,
    title: 'Scg31 Choco Baby',
    url: 'https://shop.silikomart.com/en/scg-31-choco-baby',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 6,
    dimensions: '35mm x 32mm x h15mm',
    id: 107,
    title: 'Scg32 Choco Fruits',
    url: 'https://shop.silikomart.com/en/scg-32-choco-fruits',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 12,
    dimensions: '86mm x 38mm x h14mm',
    id: 108,
    title: 'Scg33 Choco Keys',
    url: 'https://shop.silikomart.com/en/scg-33-choco-keys',
  },
  {
    brand: 'Silikomart',
    cavityCount: 18,
    cavityVolume: 5,
    dimensions: '110mm x 240mm x h13mm, \u00d827mm',
    id: 109,
    title: 'Scg34 Choco Goal',
    url: 'https://shop.silikomart.com/en/choco-goal',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 6.7,
    dimensions: '31mm x 29mm x h15mm',
    id: 110,
    title: 'Scg35 Choco Pigs',
    url: 'https://shop.silikomart.com/en/choco-pigs',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 92,
    dimensions: '115mm x 77mm x h9mm',
    id: 111,
    title: 'Scg36 Classic Choco Bar',
    url: 'https://shop.silikomart.com/en/classic-choco-bar',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 91,
    dimensions: '154mm x 77mm x h9mm',
    id: 112,
    title: 'Scg37 Tablette Choco Bar',
    url: 'https://shop.silikomart.com/en/tablette-choco-bar',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 85,
    dimensions: '155mm x 76mm x h8,5mm',
    id: 113,
    title: 'Scg38 Love Choco Bar',
    url: 'https://shop.silikomart.com/en/love-choco-bar',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 85,
    dimensions: '155mm x 76mm x h8,5mm',
    id: 114,
    title: 'Scg39 Coffee Choco Bar',
    url: 'https://shop.silikomart.com/en/coffee-choco-bar',
  },
  {
    brand: 'Silikomart',
    cavityCount: 14,
    cavityVolume: 2,
    dimensions: '113mm x 240mm x h4mm, \u00d835mm',
    id: 115,
    title: 'Scg40 Choco Frozen',
    url: 'https://shop.silikomart.com/en/choco-frozen',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 3,
    dimensions: '35mm x 35mm x h6mm',
    id: 116,
    title: 'Scg41 Xmas Choco Buttons',
    url: 'https://shop.silikomart.com/en/xmas-buttons',
  },
  {
    brand: 'Silikomart',
    cavityCount: 14,
    cavityVolume: 6,
    dimensions: '34mm x 34mm x h15mm',
    id: 117,
    title: 'Scg42 Starfish',
    url: 'https://shop.silikomart.com/en/starfish',
  },
  {
    brand: 'Silikomart',
    cavityCount: 14,
    cavityVolume: 5,
    dimensions: '120mm x 240mm x h24mm, \u00d836mm',
    id: 118,
    title: 'Scg43 Choco Melody',
    url: 'https://shop.silikomart.com/en/choco-melody',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 3,
    dimensions: '110mm x 240mm x h7mm, \u00d835mm',
    id: 119,
    title: 'Scg44 Choco Garden',
    url: 'https://shop.silikomart.com/en/choco-garden',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 7,
    dimensions: '110mm x 240mm x h15mm, \u00d830mm',
    id: 120,
    title: 'Scg45 Winter Stars',
    url: 'https://shop.silikomart.com/en/winter-stars',
  },
  {
    brand: 'Silikomart',
    cavityCount: 4,
    cavityVolume: 14,
    dimensions: '56mm x 75mm x h8mm',
    id: 121,
    title: 'Scg46 Choco Pine',
    url: 'https://shop.silikomart.com/en/choco-pine',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 8.6,
    dimensions: '34mm x 34mm x h15mm',
    id: 122,
    title: 'Scg30 Easter Friends',
    url: 'https://shop.silikomart.com/en/scg030-easter-friends',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 10,
    dimensions: '110mm x 240mm x h20mm, \u00d828mm',
    id: 123,
    title: 'Scg03 Imperial',
    url: 'https://shop.silikomart.com/en/scg-03-imperial',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 10,
    dimensions: '241mm x 28mm x h20mm, \u00d828mm',
    id: 124,
    title: 'Scg04 Vertigo',
    url: 'https://shop.silikomart.com/en/scg-04-vertigo',
  },
  {
    brand: 'Silikomart',
    cavityCount: 14,
    cavityVolume: 6.2,
    dimensions: '30mm x 43mm x h16mm',
    id: 125,
    title: 'Scg05 Easter',
    url: 'https://shop.silikomart.com/en/scg-05-easter',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 8,
    dimensions: '34mm x 34mm x h19mm',
    id: 126,
    title: 'Scg06 Christmas',
    url: 'https://shop.silikomart.com/en/scg-06-christmas',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 10,
    dimensions: '241mm x 28mm x h19mm, \u00d830mm',
    id: 127,
    title: 'Scg07 Praline',
    url: 'https://shop.silikomart.com/en/scg-07-praline',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 9,
    dimensions: '30mm x 30mm x h15,5mm',
    id: 128,
    title: 'Scg08 Fleury',
    url: 'https://shop.silikomart.com/en/scg-08-fleury',
  },
  {
    brand: 'Silikomart',
    cavityCount: 14,
    cavityVolume: 8,
    dimensions: '37mm x 20mm x h20mm',
    id: 129,
    title: 'Scg09 Jack',
    url: 'https://shop.silikomart.com/en/scg-09-jack',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 11,
    dimensions: '51mm x 23mm x h15mm',
    id: 130,
    title: 'Scg10 Nature',
    url: 'https://shop.silikomart.com/en/scg-10-nature',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 3.5,
    dimensions: '38mm x 28mm x h4,5mm',
    id: 131,
    title: 'Scg11 Tablette',
    url: 'https://shop.silikomart.com/en/scg-11-tablette',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 7,
    dimensions: '43mm x 35mm x h12mm',
    id: 132,
    title: 'Scg12 Mr Ginger',
    url: 'https://shop.silikomart.com/en/scg-12-mr-ginger',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 7,
    dimensions: '241mm x 28mm x h18mm, \u00d828mm',
    id: 133,
    title: 'Scg13 Rose',
    url: 'https://shop.silikomart.com/en/scg-13-rose',
  },
  {
    brand: 'Silikomart',
    cavityCount: 10,
    cavityVolume: 88,
    dimensions: '257mm x 152mm x h26mm',
    id: 134,
    title: '3D Tree Choc con Preparato Gingerbread',
    url: 'https://shop.silikomart.com/en/3d-tree-choc-preparato-in-polvere-gingerbread',
  },
  {
    brand: 'Silikomart',
    cavityCount: 5,
    cavityVolume: 120,
    dimensions: '180mm x 335mm x h40mm, \u00d880mm',
    id: 135,
    title: 'Sf001 Semisfera',
    url: 'https://shop.silikomart.com/en/sf-001-cupola',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 60,
    dimensions: '180mm x 34mm x h30mm, \u00d860mm',
    id: 136,
    title: 'Sf003 Semisfera',
    url: 'https://shop.silikomart.com/en/sf003-semisfera',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 30,
    dimensions: '180mm x 34mm x h25mm, \u00d850mm',
    id: 137,
    title: 'Sf004 Semisfera',
    url: 'https://shop.silikomart.com/en/sf004-semisfera',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 20,
    dimensions: '180mm x 23mm x h20mm, \u00d840mm',
    id: 138,
    title: 'Sf005 Semisfera',
    url: 'https://shop.silikomart.com/en/sf005-semisfera',
  },
  {
    brand: 'Silikomart',
    cavityCount: 24,
    cavityVolume: 18,
    dimensions: '180mm x 23mm x h16mm, \u00d834mm',
    id: 139,
    title: 'Sf009 Pomponette',
    url: 'https://shop.silikomart.com/en/sf009-pomponette',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 40,
    dimensions: '180mm x 23mm x h17mm, \u00d860mm',
    id: 140,
    title: 'Sf015 Tartelletta',
    url: 'https://shop.silikomart.com/en/sf-015-tartelletta',
  },
  {
    brand: 'Silikomart',
    cavityCount: 18,
    cavityVolume: 18,
    dimensions: '180mm x 23mm x h12mm, \u00d841mm',
    id: 141,
    title: 'Sf010 Savarin',
    url: 'https://shop.silikomart.com/en/sf010-savarin',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 20,
    dimensions: '180mm x 23mm x h10mm, \u00d845mm',
    id: 142,
    title: 'Sf013 Tartelletta',
    url: 'https://shop.silikomart.com/en/sf013-tartelletta',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 25,
    dimensions: '180mm x 23mm x h15mm, \u00d850mm',
    id: 143,
    title: 'Sf014 Tartelletta',
    url: 'https://shop.silikomart.com/en/sf-014-tartelletta',
  },
  {
    brand: 'Silikomart',
    cavityCount: 20,
    cavityVolume: 20,
    dimensions: '49mm x 26mm x h11mm',
    id: 144,
    title: 'Sf025 Finanzieri',
    url: 'https://shop.silikomart.com/en/sf-025-finanzieri',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 35,
    dimensions: '180mm x 23mm x h20mm, \u00d860mm',
    id: 145,
    title: 'Sf029 Fiorentine',
    url: 'https://shop.silikomart.com/en/sf-029-fiorentine',
  },
  {
    brand: 'Silikomart',
    cavityCount: 24,
    cavityVolume: 5,
    dimensions: '180mm x 306mm x h5mm, \u00d835mm',
    id: 146,
    title: 'Sf030 Fiorentine',
    url: 'https://shop.silikomart.com/en/sf-030-fiorentine',
  },
  {
    brand: 'Silikomart',
    cavityCount: 5,
    cavityVolume: 130,
    dimensions: '102mm x 73mm x h36mm',
    id: 147,
    title: 'Sf041 Mezzo Uovo',
    url: 'https://shop.silikomart.com/en/sf-041-mezzo-uovo',
  },
  {
    brand: 'Silikomart',
    cavityCount: 18,
    cavityVolume: 20,
    dimensions: '180mm x 335mm x h23mm, \u00d835mm',
    id: 148,
    title: 'Sf048 Diamante',
    url: 'https://shop.silikomart.com/en/sf-048-diamante',
  },
  {
    brand: 'Silikomart',
    cavityCount: 7,
    cavityVolume: 50,
    dimensions: '95mm x 45mm x h12mm',
    id: 149,
    title: 'Sf054 Finanzieri',
    url: 'https://shop.silikomart.com/en/sf-054-finanzieri',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 10,
    dimensions: '30mm x 22mm x h25mm',
    id: 150,
    title: 'Scg01 Monamour',
    url: 'https://shop.silikomart.com/en/scg-01-monamour',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 10,
    dimensions: '26mm x 26mm x h18mm',
    id: 151,
    title: 'Scg02 Cubo',
    url: 'https://shop.silikomart.com/en/scg-02-cubo',
  },
  {
    brand: 'Silikomart',
    cavityCount: 14,
    cavityVolume: 7,
    dimensions: '41mm x 30mm x h12mm',
    id: 152,
    title: 'Scg14 Fashion',
    url: 'https://shop.silikomart.com/en/scg-14-fashion',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 8,
    dimensions: '33mm x 34mm x h17mm',
    id: 153,
    title: 'Scg15 Mood',
    url: 'https://shop.silikomart.com/en/scg-15-mood',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 8,
    dimensions: '40mm x 33mm x h16mm',
    id: 154,
    title: 'Scg16 Dino',
    url: 'https://shop.silikomart.com/en/scg-16-dino',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 7,
    dimensions: '43,6mm x 29mm x h15mm',
    id: 155,
    title: 'Scg17 Teatime',
    url: 'https://shop.silikomart.com/en/scg-017-teatime',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 10,
    dimensions: '39,5mm x 27mm x h16mm',
    id: 156,
    title: 'Scg18 Robochoc',
    url: 'https://shop.silikomart.com/en/scg-018-robochoc',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 6.5,
    dimensions: '28mm x 241mm x h15mm, \u00d828,5mm',
    id: 157,
    title: 'Scg19 Fantasia',
    url: 'https://shop.silikomart.com/en/scg-19-fantasia',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 7.5,
    dimensions: '110mm x 240mm x h28mm, \u00d826mm',
    id: 158,
    title: 'Scg20 Kono',
    url: 'https://shop.silikomart.com/en/scg-20-kono',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 3,
    dimensions: '240mm x 18mm x h7mm, \u00d830mm',
    id: 159,
    title: 'Scg21 Choco Macaron',
    url: 'https://shop.silikomart.com/en/scg021-choco-macarons',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 6,
    dimensions: '39mm x 24,5mm x h13mm',
    id: 160,
    title: 'Scg22 Good Morning',
    url: 'https://shop.silikomart.com/en/scg022-good-morning',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 8,
    dimensions: '33mm x 27mm x h15mm',
    id: 161,
    title: 'Scg23 Choco Winter',
    url: 'https://shop.silikomart.com/en/scg-23-choco-winter',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 7.5,
    dimensions: '36mm x 26mm x h15mm',
    id: 162,
    title: 'Scg24 Choco Springlife',
    url: 'https://shop.silikomart.com/en/scg-24-choco-springlife',
  },
  {
    brand: 'Silikomart',
    cavityCount: 32,
    cavityVolume: 3.5,
    dimensions: '270mm x 25mm x h170mm, \u00d8130mm',
    id: 163,
    title: 'C3d 01 3D Tree Choc',
    url: 'https://shop.silikomart.com/en/3d-tree-choc',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 7,
    dimensions: '47mm x 40mm x h7mm',
    id: 164,
    title: 'Scg25 Choco Biscuit',
    url: 'https://shop.silikomart.com/en/scg025-choco-biscuits',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 7.5,
    dimensions: '34mm x 30mm x h15mm',
    id: 165,
    title: 'Scg26 Choco Gufi',
    url: 'https://shop.silikomart.com/en/scg-026-choco-gufi',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 9,
    dimensions: '35mm x 30mm x h16mm',
    id: 166,
    title: 'Scg27 Choco Angels',
    url: 'https://shop.silikomart.com/en/scg-027-choco-angels',
  },
  {
    brand: 'Silikomart',
    cavityCount: 7,
    cavityVolume: 6,
    dimensions: '96mm x 26mm x h7mm',
    id: 167,
    title: 'Scg28 Choco Spoon',
    url: 'https://shop.silikomart.com/en/scg028-choco-spoons',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 3.3,
    dimensions: '30mm x 30mm x h6mm, \u00d835mm',
    id: 168,
    title: 'Scg29 Choco Botton',
    url: 'https://shop.silikomart.com/en/scg029-choco-buttons',
  },
  {
    brand: 'Silikomart',
    cavityCount: 9,
    cavityVolume: 42,
    dimensions: '84mm x 85,5 mlmm x h14mm',
    id: 169,
    title: 'Hsh 03/B My Easter Cookies',
    url: 'https://shop.silikomart.com/en/hsh03b-my-easter-cookies',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 32.6,
    dimensions: '310mm x 350mm x h151mm, \u00d8104mm',
    id: 170,
    title: '3D Egg Choc',
    url: 'https://shop.silikomart.com/en/3d-egg-choc',
  },
  {
    brand: 'Silikomart',
    cavityCount: 4,
    cavityVolume: 34,
    dimensions: '76mm x 72mm x h12mm',
    id: 171,
    title: 'Pop03 Magic Pop',
    url: 'https://shop.silikomart.com/en/easy-pop-pop03-magic-pop',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 5.5,
    dimensions: '47mm x 57mm x h5mm',
    id: 172,
    title: 'Ckc01 Snowman Slim',
    url: 'https://shop.silikomart.com/en/ckc01-cookie-snowman-kit-slim',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 5.6,
    dimensions: '153mm x 110mm x h5mm, \u00d857mm',
    id: 173,
    title: 'Ckc02 Cookie Xmas Slim',
    url: 'https://shop.silikomart.com/en/ckc02-cookie-xmas-kit-slim',
  },
  {
    brand: 'Silikomart',
    cavityCount: 4,
    cavityVolume: 35,
    dimensions: '170mm x 220mm x h12mm, \u00d872mm',
    id: 174,
    title: 'Pop01 Lolly Pop',
    url: 'https://shop.silikomart.com/en/easy-pop-pop01-lolli-pop',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 5.6,
    dimensions: '153mm x 110mm x h4mm, \u00d857mm',
    id: 175,
    title: 'Ckc05 Cookie Dolce Vita Slim',
    url: 'https://shop.silikomart.com/en/ckc05-cookie-dolce-vita-kit-slim',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 8.5,
    dimensions: '64mm x 63mm x h4,5mm',
    id: 176,
    title: 'Ckc06 Cookie Love Slim',
    url: 'https://shop.silikomart.com/en/ckc-06-cookie-love-kit-slim',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 5.5,
    dimensions: '47mm x 57mm x h4,5mm',
    id: 177,
    title: 'Ckc 12 Cookie Monsters Slim',
    url: 'https://shop.silikomart.com/en/ckc12-cookie-monsters',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 5.5,
    dimensions: '47mm x 57mm x h4,5mm',
    id: 178,
    title: 'Ckc13 Country Slim',
    url: 'https://shop.silikomart.com/en/ckc13-slim-cookie-country',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 5.6,
    dimensions: '150mm x 110mm x h4,5mm, \u00d857mm',
    id: 179,
    title: 'Ckc14 Easter Slim',
    url: 'https://shop.silikomart.com/en/ckc14-slim-cookie-easter',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 5.6,
    dimensions: '50mm x 25mm x h12mm',
    id: 180,
    title: 'Sealife',
    url: 'https://shop.silikomart.com/en/smo-07-sea-life',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 5,
    dimensions: '168mm x 118mm x h13mm',
    id: 181,
    title: 'Parrots',
    url: 'https://shop.silikomart.com/en/smo-08-parrots',
  },
  {
    brand: 'Silikomart',
    cavityCount: 24,
    cavityVolume: 8.6,
    dimensions: '150mm x 150mm x h21,35mm',
    id: 182,
    title: 'Toffee',
    url: 'https://shop.silikomart.com/en/smo-11-toffee',
  },
  {
    brand: 'Silikomart',
    cavityCount: 9,
    cavityVolume: 50,
    dimensions: '90mm x 71mm x h14mm',
    id: 183,
    title: 'Hsh 03/A My Easter Cookies',
    url: 'https://shop.silikomart.com/en/hsh03a-my-easter-cookies',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 40,
    dimensions: '305mm x 305mm x h16,5mm',
    id: 184,
    title: 'Hsh07 My Lovely Cookies',
    url: 'https://shop.silikomart.com/en/my-lovely-cookies',
  },
  {
    brand: 'Silikomart',
    cavityCount: 4,
    cavityVolume: 40,
    dimensions: '74mm x 74mm x h12mm',
    id: 185,
    title: 'Pop04 Daisy Pop',
    url: 'https://shop.silikomart.com/en/easy-pop-pop04-daisy-pop',
  },
  {
    brand: 'Silikomart',
    cavityCount: 16,
    cavityVolume: 4.5,
    dimensions: '161mm x 192mm x h29mm, \u00d84,5mm',
    id: 186,
    title: 'Ec01 Tutti Frutti',
    url: 'https://shop.silikomart.com/en/ec01-easy-candy-tutti-frutti',
  },
  {
    brand: 'Silikomart',
    cavityCount: 16,
    cavityVolume: 3.5,
    dimensions: '161mm x 192mm x h29mm',
    id: 187,
    title: 'Ec03 Sweet Treats',
    url: 'https://shop.silikomart.com/en/ec03-easy-candy-sweet-treats',
  },
  {
    brand: 'Silikomart',
    cavityCount: 16,
    cavityVolume: 3.5,
    dimensions: '153mm x 110mm x h50mm',
    id: 188,
    title: 'Ec03 Sweet Treats SLIM',
    url: 'https://shop.silikomart.com/en/ec03-easy-candy-sweet-treats-slim',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1200,
    dimensions: '220mm x 70mm x h65mm, \u00d8185mm',
    id: 189,
    title: 'Coco3 Coco Choc',
    url: 'https://shop.silikomart.com/en/coc03-coco-choc',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 150,
    dimensions: '72mm x 101mm x h65mm',
    id: 190,
    title: 'Coc06 Choco Pot',
    url: 'https://shop.silikomart.com/en/coc06-choco-pot',
  },
  {
    brand: 'Silikomart',
    cavityCount: 25,
    cavityVolume: 5.6,
    dimensions: '28mm x 28mm x h13mm',
    id: 191,
    title: 'Ca01 Creative Xmas Countdown',
    url: 'https://shop.silikomart.com/en/ca-01-creative-xmas-countdown',
  },
  {
    brand: 'Silikomart',
    cavityCount: 66,
    cavityVolume: 33,
    dimensions: '180mm x 306mm x h30mm, \u00d818mm',
    id: 192,
    title: 'Sf131 Cono',
    url: 'https://shop.silikomart.com/en/sf131-cono-508',
  },
  {
    brand: 'Silikomart',
    cavityCount: 19,
    cavityVolume: 8,
    dimensions: '120mm x 35mm x h12,5mm',
    id: 193,
    title: 'My Chocolate Spoon',
    url: 'https://shop.silikomart.com/en/my-chocolate-spoon',
  },
  {
    brand: 'Silikomart',
    cavityCount: 16,
    cavityVolume: 12.75,
    dimensions: '59mm x 29mm x h6,8mm',
    id: 194,
    title: 'Sf146 Xmas Choco Tags',
    url: 'https://shop.silikomart.com/en/sf-146-xmas-choco-tags',
  },
  {
    brand: 'Silikomart',
    cavityCount: 11,
    cavityVolume: 14.54,
    dimensions: '62mm x 40mm x h8mm',
    id: 195,
    title: 'Choco Flash',
    url: 'https://shop.silikomart.com/en/sf-151-choco-flash',
  },
  {
    brand: 'Silikomart',
    cavityCount: 81,
    cavityVolume: 1.41,
    dimensions: '180mm x 335mm x h15mm',
    id: 196,
    title: 'Sf169 Choco Abc',
    url: 'https://shop.silikomart.com/en/sf169-choco-abc',
  },
  {
    brand: 'Silikomart',
    cavityCount: 10,
    cavityVolume: 88,
    dimensions: '257mm x 152mm x h26mm',
    id: 197,
    title: 'Sf173 Chocolat',
    url: 'https://shop.silikomart.com/en/sf173-chocolat',
  },
  {
    brand: 'Silikomart',
    cavityCount: 60,
    cavityVolume: 2.06,
    dimensions: '180mm x 335mm x h15mm',
    id: 198,
    title: 'Sf174 Choco 123',
    url: 'https://shop.silikomart.com/en/sf174-choco123',
  },
  {
    brand: 'Silikomart',
    cavityCount: 16,
    cavityVolume: 10.5,
    dimensions: '300mm x 175mm x h9mm',
    id: 199,
    title: 'Sf195 Safari Choco Tags',
    url: 'https://shop.silikomart.com/en/sf-195-safari-choco-tags',
  },
  {
    brand: 'Silikomart',
    cavityCount: 16,
    cavityVolume: 9,
    dimensions: '300mm x 175mm x h9mm',
    id: 200,
    title: 'Sf196 Choco Tags In Love',
    url: 'https://shop.silikomart.com/en/sf-196-choco-tags-in-love',
  },
  {
    brand: 'Silikomart',
    cavityCount: 16,
    cavityVolume: 9,
    dimensions: '300mm x 175mm x h9mm',
    id: 201,
    title: 'Sf198 Winter Choco Tags',
    url: 'https://shop.silikomart.com/en/sf-198-winter-choco-tags',
  },
  {
    brand: 'Silikomart',
    cavityCount: 16,
    cavityVolume: 9,
    dimensions: '300mm x 175mm x h9mm',
    id: 202,
    title: 'Sf199 Funny Owls Choco Tags',
    url: 'https://shop.silikomart.com/en/sf-199-funny-owls-choco-tags',
  },
  {
    brand: 'Silikomart',
    cavityCount: 10,
    cavityVolume: 100,
    dimensions: '90mm x 45mm x h28mm',
    id: 203,
    title: 'Choco Block',
    url: 'https://shop.silikomart.com/en/choco-block',
  },
  {
    brand: 'Silikomart',
    cavityCount: 24,
    cavityVolume: 10,
    dimensions: '180mm x 335mm x h20mm, \u00d835mm',
    id: 204,
    title: 'Sf232 Mini Gugelhopf',
    url: 'https://shop.silikomart.com/en/mini-gugelhopf-565',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 2.45,
    dimensions: '130mm x 195mm x h5mm, \u00d825mm',
    id: 205,
    title: 'Chablon \u00d8 25mm',
    url: 'https://shop.silikomart.com/en/chablon',
  },
  {
    brand: 'Silikomart',
    cavityCount: 4,
    cavityVolume: 45,
    dimensions: '37mm x 70mm x h18mm',
    id: 206,
    title: 'Gel10m Mini Vintage',
    url: 'https://shop.silikomart.com/en/vintage',
  },
  {
    brand: 'Silikomart',
    cavityCount: 2,
    cavityVolume: 90,
    dimensions: '93mm x 49mm x h25mm',
    id: 207,
    title: 'Gel01 Classic \u2013 2 pcs',
    url: 'https://shop.silikomart.com/en/set-2-gel01-classic',
  },
  {
    brand: 'Silikomart',
    cavityCount: 2,
    cavityVolume: 90,
    dimensions: '92mm x 45mm x h27,5mm',
    id: 208,
    title: 'Gel04 Tango \u2013 2 pcs',
    url: 'https://shop.silikomart.com/en/set-2-gel04-tango',
  },
  {
    brand: 'Silikomart',
    cavityCount: 4,
    cavityVolume: 37,
    dimensions: '73mm x 38mm x h25mm',
    id: 209,
    title: 'Gel01m Mini Classic',
    url: 'https://shop.silikomart.com/en/gel01mb-mini-classic',
  },
  {
    brand: 'Silikomart',
    cavityCount: 3,
    cavityVolume: 45,
    dimensions: '67mm x 55mm x h18mm',
    id: 210,
    title: 'Gel03m Mini Heart-Ic',
    url: 'https://shop.silikomart.com/en/gel03mb-mini-heart-ic',
  },
  {
    brand: 'Silikomart',
    cavityCount: 4,
    cavityVolume: 36,
    dimensions: '67mm x 33mm x h22mm',
    id: 211,
    title: 'Gel04m Mini Tango',
    url: 'https://shop.silikomart.com/en/gel04mb-mini-tango',
  },
  {
    brand: 'Silikomart',
    cavityCount: 4,
    cavityVolume: 38,
    dimensions: '70mm x 33mm x h22mm',
    id: 212,
    title: 'Gel05m Mini Chic',
    url: 'https://shop.silikomart.com/en/gel05mb-mini-chic',
  },
  {
    brand: 'Silikomart',
    cavityCount: 3,
    cavityVolume: 72,
    dimensions: '95mm x 220mm x h200mm, \u00d842mm',
    id: 213,
    title: 'Cal 01 Stampo Ghiaccioli \u2013 3 pcs',
    url: 'https://shop.silikomart.com/en/cal-01-set-3-pezzi-stampo-ghiaccioli',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 83,
    dimensions: '80mm x 100mm x h32mm, \u00d869mm',
    id: 214,
    title: 'Cup01 Pirottini in silicone \u2013 6 pcs',
    url: 'https://shop.silikomart.com/en/cup01-set-6-cupcakes-round',
  },
  {
    brand: 'Silikomart',
    cavityCount: 3,
    cavityVolume: 1248,
    dimensions: '180mm x 180mm x h40mm',
    id: 215,
    title: 'My Wonder Cake Square',
    url: 'https://shop.silikomart.com/en/my-wondercake-square',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 80,
    dimensions: '185mm x 335mm x h35mm, \u00d870mm',
    id: 216,
    title: 'Sf002 Half Sphere',
    url: 'https://shop.silikomart.com/en/semisfera',
  },
  {
    brand: 'Silikomart',
    cavityCount: 24,
    cavityVolume: 10,
    dimensions: '175mm x 23mm x h15mm, \u00d830mm',
    id: 217,
    title: 'Sf006 Semisfera',
    url: 'https://shop.silikomart.com/en/sf006-semisfera',
  },
  {
    brand: 'Silikomart',
    cavityCount: 11,
    cavityVolume: 92,
    dimensions: '180mm x 306mm x h28mm, \u00d851mm',
    id: 218,
    title: 'Sf022 Mini Muffin',
    url: 'https://shop.silikomart.com/en/mini-muffin',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 100,
    dimensions: '180mm x 335mm x h35mm, \u00d869mm',
    id: 219,
    title: 'Sf023 Muffin',
    url: 'https://shop.silikomart.com/en/muffin',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 70,
    dimensions: '12mm x 79mm x h29mm',
    id: 220,
    title: 'Sf026 Mini Cake',
    url: 'https://shop.silikomart.com/en/mini-cake',
  },
  {
    brand: 'Silikomart',
    cavityCount: 9,
    cavityVolume: 30,
    dimensions: '68mm x 45mm x h17mm',
    id: 221,
    title: 'Sf032 Madeleine',
    url: 'https://shop.silikomart.com/en/madeleine',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 80,
    dimensions: '180mm x 306mm x h36mm, \u00d870mm',
    id: 222,
    title: 'Sf058 Gugelhopf',
    url: 'https://shop.silikomart.com/en/mini-gugelhopf',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 92,
    dimensions: '180mm x 335mm x h50mm, \u00d855mm',
    id: 223,
    title: 'Sf050 Cannel\u00e9',
    url: 'https://shop.silikomart.com/en/cannelle',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 60,
    dimensions: '180mm x 335mm x h45mm, \u00d845mm',
    id: 224,
    title: 'Sf059 Midi Cannel\u00e9',
    url: 'https://shop.silikomart.com/en/midi-cannelle',
  },
  {
    brand: 'Silikomart',
    cavityCount: 18,
    cavityVolume: 30,
    dimensions: '180mm x 335mm x h35mm, \u00d835mm',
    id: 225,
    title: 'Sf033 Mini Cannel\u00e9',
    url: 'https://shop.silikomart.com/en/mini-cannelle',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1550,
    dimensions: '260mm x 100mm x h70mm',
    id: 226,
    title: 'Sft330 Plum Cake',
    url: 'https://shop.silikomart.com/en/plum-cake',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 2200,
    dimensions: '310mm x 360mm x h45mm, \u00d8260mm',
    id: 227,
    title: 'Sft126 Stampo Rotondo',
    url: 'https://shop.silikomart.com/en/round-cake',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1500,
    dimensions: '260mm x 300mm x h55mm, \u00d8240mm',
    id: 228,
    title: 'Sft205 Ciambellone',
    url: 'https://shop.silikomart.com/en/ciambellone',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1250,
    dimensions: '280mm x 340mm x h30mm, \u00d8240mm',
    id: 229,
    title: 'Sft424 Crostata',
    url: 'https://shop.silikomart.com/en/sft-424-crostata',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1300,
    dimensions: '310mm x 360mm x h30mm, \u00d8260mm',
    id: 230,
    title: 'Sft426 Crostata',
    url: 'https://shop.silikomart.com/en/crostata',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1750,
    dimensions: '310mm x 400mm x h30mm, \u00d8280mm',
    id: 231,
    title: 'Sft428 Crostata',
    url: 'https://shop.silikomart.com/en/sft-428-crostata',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1500,
    dimensions: '220mm x 260mm x h65mm, \u00d8180mm',
    id: 232,
    title: 'Sft180 Genoise',
    url: 'https://shop.silikomart.com/en/genoise',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 2200,
    dimensions: '250mm x 280mm x h110mm, \u00d8220mm',
    id: 233,
    title: 'Sft250 Gugelhupf',
    url: 'https://shop.silikomart.com/en/gugelhopf',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 42,
    dimensions: '35mm x 35mm x h35mm',
    id: 234,
    title: 'Sf105 Cube',
    url: 'https://shop.silikomart.com/en/sf-105-cubo',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 125,
    dimensions: '50mm x 50mm x h50mm',
    id: 235,
    title: 'Sf104 Cube',
    url: 'https://shop.silikomart.com/en/sf-104-cubo-478',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 50,
    dimensions: '180mm x 20mm x h21mm, \u00d865mm',
    id: 236,
    title: 'Sf011 Savarin',
    url: 'https://shop.silikomart.com/en/sf011-savarin',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 62,
    dimensions: '157mm x 230mm x h23mm, \u00d872mm',
    id: 237,
    title: 'Sf012 Savarin',
    url: 'https://shop.silikomart.com/en/sf012-savarin',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 70,
    dimensions: '180mm x 23mm x h20mm, \u00d870mm',
    id: 238,
    title: 'Sf016 Tartelletta',
    url: 'https://shop.silikomart.com/en/sf-016-tartelletta',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 30,
    dimensions: '180mm x 335mm x h38mm, \u00d835mm',
    id: 239,
    title: 'Sf019 Bab\u00e1',
    url: 'https://shop.silikomart.com/en/sf-019-baba-apos',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 92,
    dimensions: '180mm x 335mm x h60mm, \u00d855mm',
    id: 240,
    title: 'Sf021 Bab\u00e1',
    url: 'https://shop.silikomart.com/en/sf-021-baba-apos',
  },
  {
    brand: 'Silikomart',
    cavityCount: 5,
    cavityVolume: 135,
    dimensions: '180mm x 43mm x h32mm, \u00d881mm',
    id: 241,
    title: 'Sf024 Muffin',
    url: 'https://shop.silikomart.com/en/sf-024-muffin',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 30,
    dimensions: '180mm x 23mm x h20mm, \u00d840mm',
    id: 242,
    title: 'Sf027 Petit-Fours',
    url: 'https://shop.silikomart.com/en/sf-027-petit-fours',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 90,
    dimensions: '180mm x 43mm x h35mm, \u00d860mm',
    id: 243,
    title: 'Sf028 Cilindro',
    url: 'https://shop.silikomart.com/en/sf-028-cilindro',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 10,
    dimensions: '44mm x 34mm x h10mm',
    id: 244,
    title: 'Sf031 Madeleine',
    url: 'https://shop.silikomart.com/en/sf-031-madeleine',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 110,
    dimensions: '180mm x 306mm x h30mm, \u00d879mm',
    id: 245,
    title: 'Sf034 Briochette Cannellata',
    url: 'https://shop.silikomart.com/en/sf-034-briochette-cannellata',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 110,
    dimensions: '180mm x 34mm x h30mm, \u00d879mm',
    id: 246,
    title: 'Sf035 Briochette Cannellata',
    url: 'https://shop.silikomart.com/en/sf-035-briochette-cannellata',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 130,
    dimensions: '180mm x 43mm x h40mm, \u00d865mm',
    id: 247,
    title: 'Sf036 Cuore',
    url: 'https://shop.silikomart.com/en/sf-036-cuore',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 30,
    dimensions: '180mm x 34mm x h26mm, \u00d838mm',
    id: 248,
    title: 'Sf037 Ottagono',
    url: 'https://shop.silikomart.com/en/sf-037-ottagono',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 20,
    dimensions: '72mm x 30mm x h15mm',
    id: 249,
    title: 'Sf038 Barchetta',
    url: 'https://shop.silikomart.com/en/sf-038-barchetta',
  },
  {
    brand: 'Silikomart',
    cavityCount: 9,
    cavityVolume: 40,
    dimensions: '100mm x 44mm x h15mm',
    id: 250,
    title: 'Sf039 Barchetta',
    url: 'https://shop.silikomart.com/en/sf-039-barchetta',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 20,
    dimensions: '180mm x 23mm x h13mm, \u00d840mm',
    id: 251,
    title: 'Sf043 Tortina',
    url: 'https://shop.silikomart.com/en/sf-043-tortina',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 30,
    dimensions: '180mm x 23mm x h14mm, \u00d850mm',
    id: 252,
    title: 'Sf044 Tortina',
    url: 'https://shop.silikomart.com/en/sf-044-tortina',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 72,
    dimensions: '180mm x 23mm x h18mm, \u00d880mm',
    id: 253,
    title: 'Sf047 Tortina',
    url: 'https://shop.silikomart.com/en/sf-047-tortina',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 130,
    dimensions: '180mm x 63mm x h57mm, \u00d857mm',
    id: 254,
    title: 'Sf051 Bavarese',
    url: 'https://shop.silikomart.com/en/sf-051-bavarese',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 165,
    dimensions: '180mm x 335mm x h60mm, \u00d875mm',
    id: 255,
    title: 'Sf052 Muffin',
    url: 'https://shop.silikomart.com/en/sf-052-muffin',
  },
  {
    brand: 'Silikomart',
    cavityCount: 10,
    cavityVolume: 45,
    dimensions: '48mm x 54mm x h27mm',
    id: 256,
    title: 'Sf088 Savarin Cuori Medi',
    url: 'https://shop.silikomart.com/en/sf-088-savarin-cuori-medi',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 110,
    dimensions: '75mm x 55mm x h35mm',
    id: 257,
    title: 'Sf055 Ovali',
    url: 'https://shop.silikomart.com/en/sf-055-ovali',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 80,
    dimensions: '180mm x 335mm x h28mm, \u00d870mm',
    id: 258,
    title: 'Sf056 Margherita',
    url: 'https://shop.silikomart.com/en/sf-056-margherita',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 100,
    dimensions: '180mm x 335mm x h40mm, \u00d875mm',
    id: 259,
    title: 'Sf061 Fantasy',
    url: 'https://shop.silikomart.com/en/sf-061-fantasy',
  },
  {
    brand: 'Silikomart',
    cavityCount: 24,
    cavityVolume: 16,
    dimensions: '34mm x 33mm x h21mm',
    id: 260,
    title: 'Sf089 Savarin Cuori Piccoli',
    url: 'https://shop.silikomart.com/en/sf-089-savarin-cuori-piccoli',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 83,
    dimensions: '335mm x 60mm x h50mm, \u00d848mm',
    id: 261,
    title: 'Sf098 Cilindro',
    url: 'https://shop.silikomart.com/en/sf-098-cilindro',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1000,
    dimensions: '230mm x 230mm x h40mm, \u00d8180mm',
    id: 262,
    title: 'Sft118 Stampo Rotondo',
    url: 'https://shop.silikomart.com/en/sf118-stampo-rotondo',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 4500,
    dimensions: '330mm x 220mm x h55mm',
    id: 263,
    title: 'Sft332 Lasagnera',
    url: 'https://shop.silikomart.com/en/sft-332-lasagnera',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1700,
    dimensions: '520mm x 280mm x h80mm, \u00d8220mm',
    id: 264,
    title: 'Sft522 Brioche',
    url: 'https://shop.silikomart.com/en/sft-522-brioche',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1500,
    dimensions: '195mm x 225mm x h95mm, \u00d8180mm',
    id: 265,
    title: 'Sft313 Goal',
    url: 'https://shop.silikomart.com/en/sft-313-goal',
  },
  {
    brand: 'Silikomart',
    cavityCount: 4,
    cavityVolume: 68,
    dimensions: '50,5mm x 60mm x h34mm',
    id: 266,
    title: 'Hsf01 Happy Xmas',
    url: 'https://shop.silikomart.com/en/hsf01-happy-xmas',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 70,
    dimensions: '175mm x 44mm x h42,5mm, \u00d855mm',
    id: 267,
    title: 'Sf113 Flu',
    url: 'https://shop.silikomart.com/en/sf113-flu',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 119,
    dimensions: '181mm x 42mm x h38mm, \u00d868mm',
    id: 268,
    title: 'Sf102 Medium Muffin',
    url: 'https://shop.silikomart.com/en/sf-102-medium-muffin',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 84,
    dimensions: '127,5mm x 47mm x h17mm',
    id: 269,
    title: 'Sf103 Savoiardo',
    url: 'https://shop.silikomart.com/en/sf-103-savoiardo-476',
  },
  {
    brand: 'Silikomart',
    cavityCount: 12,
    cavityVolume: 33,
    dimensions: '180mm x 335mm x h22mm, \u00d858mm',
    id: 270,
    title: 'Sf109 Mini Briochette',
    url: 'https://shop.silikomart.com/en/sf-109-mini-briochette-483',
  },
  {
    brand: 'Silikomart',
    cavityCount: 7,
    cavityVolume: 97,
    dimensions: '87mm x 48mm x h24mm',
    id: 271,
    title: 'Sf110 Rettangolo',
    url: 'https://shop.silikomart.com/en/sf110-rettangolo',
  },
  {
    brand: 'Silikomart',
    cavityCount: 9,
    cavityVolume: 83,
    dimensions: '84mm x 32mm x h35mm',
    id: 272,
    title: 'Sf130 Midi Buche',
    url: 'https://shop.silikomart.com/en/sf130-midi-buche',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 123,
    dimensions: '180mm x 335mm x h40mm, \u00d863mm',
    id: 273,
    title: 'Sf119 Cylinders',
    url: 'https://shop.silikomart.com/en/sf-119-cilindro',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 133,
    dimensions: '180mm x 43mm x h35mm, \u00d870mm',
    id: 274,
    title: 'Sf127 Cylinders',
    url: 'https://shop.silikomart.com/en/sf-127-cilindro',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 102,
    dimensions: '180mm x 335mm x h41mm, \u00d870mm',
    id: 275,
    title: 'Sf154 Charlotte',
    url: 'https://shop.silikomart.com/en/sf154-charlotte',
  },
  {
    brand: 'Silikomart',
    cavityCount: 4,
    cavityVolume: 137,
    dimensions: '130mm x 81mm x h17mm',
    id: 276,
    title: 'Sf155 Waffel Classic',
    url: 'https://shop.silikomart.com/en/sf155-waffel-classic',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1500,
    dimensions: '65mm, \u00d8180mm',
    id: 277,
    title: 'Sft180 Stampo Rotondo',
    url: 'https://shop.silikomart.com/en/sft-180',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1050,
    dimensions: '230mm x 310mm x h40mm, \u00d8200mm',
    id: 278,
    title: 'Sft120 Stampo Rotondo',
    url: 'https://shop.silikomart.com/en/sft-120-stampo-rotondo',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1400,
    dimensions: '280mm x 340mm x h42mm, \u00d8220mm',
    id: 279,
    title: 'Sft122 Stampo Rotondo',
    url: 'https://shop.silikomart.com/en/sft-122-stampo-rotondo',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1700,
    dimensions: '250mm x 30mm x h42mm, \u00d8240mm',
    id: 280,
    title: 'Sft124',
    url: 'https://shop.silikomart.com/en/sft-124-stampo-rotondo',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 2500,
    dimensions: '295mm x 390mm x h47mm, \u00d8280mm',
    id: 281,
    title: 'Sft128 Stampo Rotondo',
    url: 'https://shop.silikomart.com/en/sft-128-stampo-rotondo',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1250,
    dimensions: '60mm, \u00d8240mm',
    id: 282,
    title: 'Sft224 Ciambella con anello',
    url: 'https://shop.silikomart.com/en/sft-224-pizza',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 2500,
    dimensions: '310mm x 390mm x h55mm, \u00d8260mm',
    id: 283,
    title: 'Sft226 Tortiera con anello',
    url: 'https://shop.silikomart.com/en/sft-226-stampo-rotondo',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 2250,
    dimensions: '280mm x 220mm x h40mm',
    id: 284,
    title: 'Sft300 Rettangolare',
    url: 'https://shop.silikomart.com/en/sft-300-rettangolare',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 2300,
    dimensions: '228mm x 228mm x h50mm',
    id: 285,
    title: 'Sft306 Quadrato',
    url: 'https://shop.silikomart.com/en/sft-306-quadrato',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1500,
    dimensions: '240mm x 110mm x h65mm',
    id: 286,
    title: 'Sft326 Plum Cake',
    url: 'https://shop.silikomart.com/en/sft-326-plum-cake',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1700,
    dimensions: '300mm x 100mm x h70mm',
    id: 287,
    title: 'Sft331 Plum Cake',
    url: 'https://shop.silikomart.com/en/sft-331-plum-cake',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 98,
    dimensions: '182mm x 333mm x h28mm, \u00d875mm',
    id: 288,
    title: 'DONUTS - STAMPO IN SILICONE \u00f875/25 H28 MM',
    url: 'https://shop.silikomart.com/en/donuts-stampo-in-silicone-o75-25-h28-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 409,
    dimensions: '58mm, \u00d8115mm',
    id: 289,
    title: 'MINI DOME - STAMPO IN SILICONE \u00f8115 H58 MM',
    url: 'https://shop.silikomart.com/en/mini-dome-stampo-in-silicone-o115-h58-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 102,
    dimensions: '41mm, \u00d870mm',
    id: 290,
    title: 'SF154 CHARLOTTE',
    url: 'https://shop.silikomart.com/en/sf154-charlotte-stampo-in-silicone-o70-h-41-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 20,
    dimensions: '50mm x 38mm x h20mm, \u00d843mm',
    id: 291,
    title: 'SF135 MINI SPRINGLIFE',
    url: 'https://shop.silikomart.com/en/sf135-mini-springlife-stampo-in-silicone-o43-h-20-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 80,
    dimensions: '77mm x 57mm x h32mm, \u00d869mm',
    id: 292,
    title: 'SF117 SPRINGLIFE',
    url: 'https://shop.silikomart.com/en/sf117-springlife-stampo-in-silicone-o69-h32-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1804,
    dimensions: '253mm x 290mm x h40mm, \u00d8240mm',
    id: 293,
    title: 'Perla24',
    url: 'https://shop.silikomart.com/en/perla-24',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1252,
    dimensions: '222mm x 260mm x h40mm, \u00d8200mm',
    id: 294,
    title: 'Perla 20',
    url: 'https://shop.silikomart.com/en/perla-20',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1500,
    dimensions: '280mm x 275mm x h60mm, \u00d8220mm',
    id: 295,
    title: 'Armony',
    url: 'https://shop.silikomart.com/en/armony',
  },
  {
    brand: 'Silikomart',
    cavityCount: 4,
    cavityVolume: 106,
    dimensions: '77mm x 57mm x h28mm',
    id: 296,
    title: 'Hsf06 Happy Toys',
    url: 'https://shop.silikomart.com/en/hsf06-happy-toys',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 62.5,
    dimensions: '76,5mm x 50,5mm x h29,5mm',
    id: 297,
    title: 'Sf118 Tulip',
    url: 'https://shop.silikomart.com/en/stampo-in-silicone-nr-8-tulipano-76-5-x-50-5-h-29-5-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1200,
    dimensions: '260mm x 310mm x h40mm, \u00d8260mm',
    id: 298,
    title: 'Sft201 Etolie',
    url: 'https://shop.silikomart.com/en/sft-201-etoile',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 2200,
    dimensions: '235mm x 235mm x h83mm, \u00d8220mm',
    id: 299,
    title: 'Sft324 Bon Ton',
    url: 'https://shop.silikomart.com/en/sft324-bonton-natale',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 2200,
    dimensions: '235mm x 80mm x h83,3mm, \u00d8220mm',
    id: 300,
    title: 'Sft324 Easter',
    url: 'https://shop.silikomart.com/en/sft324-bonton-easter',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1200,
    dimensions: '235mm x 170mm x h60mm',
    id: 301,
    title: 'Sft327 Croissant',
    url: 'https://shop.silikomart.com/en/sft327-croissant',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 84,
    dimensions: '74mm x 66mm x h33mm',
    id: 302,
    title: 'Sf191 Fairy Owls',
    url: 'https://shop.silikomart.com/en/sf-191-fairy-owls',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 2700,
    dimensions: '229mm x 229mm x h60mm',
    id: 303,
    title: 'Sft333 Jingle Bells',
    url: 'https://shop.silikomart.com/en/sft333-jingle-bells',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1300,
    dimensions: '245mm x 230mm x h40mm',
    id: 304,
    title: 'Sft335 Pirates Boat',
    url: 'https://shop.silikomart.com/en/sft-335-pirates-boat',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 260,
    dimensions: '135mm x 138mm x h32mm',
    id: 305,
    title: 'Sft808 Elefante',
    url: 'https://shop.silikomart.com/en/sft-808-elefante',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 2300,
    dimensions: '280mm x 215mm x h50mm',
    id: 306,
    title: 'Sft302 Daisy Pan',
    url: 'https://shop.silikomart.com/en/sft-302-daisy-pan',
  },
  {
    brand: 'Silikomart',
    cavityCount: 2,
    cavityVolume: 300,
    dimensions: '130mm x 130mm x h50mm, \u00d8126mm',
    id: 307,
    title: 'Sft817 Small Rose \u2013 2 pcs',
    url: 'https://shop.silikomart.com/en/sft-817-set-2-pezzi-small-rose',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 117,
    dimensions: '80,5mm x 67mm x h37mm',
    id: 308,
    title: 'Sf137 Funny Christmas',
    url: 'https://shop.silikomart.com/en/sf137-funny-christmas',
  },
  {
    brand: 'Silikomart',
    cavityCount: 8,
    cavityVolume: 77.37,
    dimensions: '84mm x 86mm x h29mm',
    id: 309,
    title: 'Sf157 Good Morning',
    url: 'https://shop.silikomart.com/en/sf157-good-morning',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 177,
    dimensions: '180mm x 340mm x h60mm, \u00d875mm',
    id: 310,
    title: 'Sf168 Mini Wonder Cake Square',
    url: 'https://shop.silikomart.com/en/sf168-mini-wonder-cake-square',
  },
  {
    brand: 'Silikomart',
    cavityCount: 18,
    cavityVolume: 19,
    dimensions: '300mm x 175mm x h23,5mm',
    id: 311,
    title: 'Sf182 Stelle',
    url: 'https://shop.silikomart.com/en/mini-stars',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 115,
    dimensions: '180mm x 310mm x h42mm, \u00d838mm',
    id: 312,
    title: 'Sf201 Igloo',
    url: 'https://shop.silikomart.com/en/igloo',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 22,
    dimensions: '300mm x 175mm x h22mm',
    id: 313,
    title: 'Sf207 Sweet Baby',
    url: 'https://shop.silikomart.com/en/sweet-baby',
  },
  {
    brand: 'Silikomart',
    cavityCount: 15,
    cavityVolume: 22,
    dimensions: '300mm x 175mm x h22mm',
    id: 314,
    title: 'Sf208 Fancy Toys',
    url: 'https://shop.silikomart.com/en/fancy-toys',
  },
  {
    brand: 'Silikomart',
    cavityCount: 6,
    cavityVolume: 100,
    dimensions: '40mm, \u00d875mm',
    id: 315,
    title: 'SF061 FANTASY',
    url: 'https://shop.silikomart.com/en/sf061-stampo-in-silicone-fantasy-o75-h-40-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1100,
    dimensions: '205mm x 186mm x h54mm',
    id: 316,
    title: 'SFT211 LOVE',
    url: 'https://shop.silikomart.com/en/sft211-love-stampo-in-silicone-205x186-h-54-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 1100,
    dimensions: '75mm, \u00d8180mm',
    id: 317,
    title: 'SFT182 VERTIGO',
    url: 'https://shop.silikomart.com/en/sft182-vertigo-stampo-in-silicone-o180-h75-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 2200,
    dimensions: '100mm, \u00d8220mm',
    id: 318,
    title: 'SFT303 CATHEDRAL',
    url: 'https://shop.silikomart.com/en/sft303-cathedral-stampo-in-silicone-o220-h-100-mm',
  },
  {
    brand: 'Silikomart',
    cavityCount: 1,
    cavityVolume: 2300,
    dimensions: '100mm, \u00d8240mm',
    id: 319,
    title: 'SFT600 METEOR',
    url: 'https://shop.silikomart.com/en/sft600-meteor-stampo-in-silicone-o240-h-100-mm',
  },
  {
    brand: 'Pavoni',
    cavityCount: 5,
    cavityVolume: 400,
    dimensions: '',
    id: 320,
    title: 'BAMBOO PX4318',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/3163/s/bamboo-px4318/category/674/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 5,
    cavityVolume: 360,
    dimensions: '',
    id: 321,
    title: 'VOLUPTE PX4311',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/3165/s/volupte-px4311/category/674/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 20,
    cavityVolume: 110,
    dimensions: '',
    id: 322,
    title: 'SPHERE PX4350',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/4354/s/sphere-px4350/category/676/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 1850,
    dimensions: '',
    id: 323,
    title: 'ROUND FRT003',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/2854/s/round-frt003/category/677/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 24,
    cavityVolume: 7,
    dimensions: '',
    id: 324,
    title: 'Margherita PX4383S',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/single-serving-mignon/margherita-px4383s.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 1400,
    dimensions: '',
    id: 325,
    title: 'ROUND FRT002',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/2853/s/round-frt002/category/677/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 12,
    cavityVolume: 100,
    dimensions: '\u00d8\u00a072 x h 40 mm',
    id: 326,
    title: 'Fa\u00e7on Saint-Honor\u00e9 PX4384S',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/single-serving-mignon/facon-saint-honore-px4384s.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 30,
    cavityVolume: 20,
    dimensions: '',
    id: 327,
    title: 'Sfogliatella',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/single-serving-mignon/px4378s-sfogliatella.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 2670,
    dimensions: '280 X 240 mm - h 40 mm',
    id: 328,
    title: 'RECTANGULAR CAKE MOULD FRT077',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/2864/s/rectangular-cake-mold-frt077/category/677/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 1700,
    dimensions: '',
    id: 329,
    title: 'TART MOULD FRT058',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/2863/s/tart-mold-frt058/category/677/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 8,
    cavityVolume: 28,
    dimensions: '\u00d8 60x14 h mm',
    id: 330,
    title: 'Mini Almonds TOP22 - almond shape',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/single-serving-mignon/mini-walnut-top22.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 1350,
    dimensions: '',
    id: 331,
    title: 'FLUTED CAKE MOULD FRT051',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/2856/s/fluted-cake-mold-frt051/category/677/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 1000,
    dimensions: '',
    id: 332,
    title: 'KE075S CADEAU',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/torte/cadeau-ke075s.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 5,
    cavityVolume: 410,
    dimensions: '',
    id: 333,
    title: 'PLUMMY PX4320',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/3162/s/plummy-px4320/category/674/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 14,
    cavityVolume: 90,
    dimensions: 'mm 124x35x30 h',
    id: 334,
    title: 'SEQUOIA PX4387S',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/single-serving-mignon/sequoia-px4387.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 5,
    cavityVolume: 600,
    dimensions: '',
    id: 335,
    title: 'PX060',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/3933/s/px060/category/674/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 966,
    dimensions: '\u00d8 mm 180x50 h',
    id: 336,
    title: 'SUNNY',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/5579/s/sunny-ke064/category/675/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 8,
    cavityVolume: 46,
    dimensions: '',
    id: 337,
    title: 'Charm',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/single-serving-mignon/px3209s-charm.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 15,
    cavityVolume: 96,
    dimensions: '',
    id: 338,
    title: 'Bab\u00e0',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/single-serving-mignon/px4382s-baba.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 1850,
    dimensions: '',
    id: 339,
    title: 'ROUND FLUTED CAKE MOULD FRT053',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/2858/s/round-fluted-cake-mold-frt053/category/677/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 600,
    dimensions: '',
    id: 340,
    title: 'MINI CADEAU KE076S',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/5824/s/mini-cadeau-ke076s/category/675/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 380,
    dimensions: '\u00d8 mm 180x22 h',
    id: 341,
    title: 'Raven TOP24 - blackberry shape',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/5751/s/raven-top24/category/675/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 5,
    cavityVolume: 360,
    dimensions: '',
    id: 342,
    title: 'CANDY PX4309',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/3166/s/candy-px4309/category/674/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 414,
    dimensions: '\u00d8 mm 160x37 h',
    id: 343,
    title: 'Frisbee',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/5665/s/top18s-frisbee/category/675/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 4,
    cavityVolume: 2376,
    dimensions: 'mm 560x80x63 H',
    id: 344,
    title: 'PX059 TRONCHETTO',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/3411/s/px059-tronchetto/category/674/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 8,
    cavityVolume: 49.5,
    dimensions: '\u00d8 mm 60x32 h',
    id: 345,
    title: 'Step',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/single-serving-mignon/px3210s-step.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 8,
    cavityVolume: 82,
    dimensions: '68X68X31 mm',
    id: 346,
    title: 'FR082 CUORE',
    url: 'https://pavonitalia.com/professional/en/collezioni/pasticceria/formaflex/fr082-cuore.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 30,
    cavityVolume: 14,
    dimensions: '',
    id: 347,
    title: 'SPHERE PX4313',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/3147/s/sphere-px4313/category/676/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 130,
    cavityVolume: 2,
    dimensions: '',
    id: 348,
    title: 'SPHERE PX4339',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/4353/s/sphere-px4339/category/676/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 1006,
    dimensions: 'mm 167x158x40 h',
    id: 349,
    title: 'JUPITER',
    url: 'https://pavonitalia.com/professional/en/collezioni/pasticceria/torte/jupiter-ke063.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 9,
    cavityVolume: 124,
    dimensions: '',
    id: 350,
    title: 'PX058',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/3932/s/px058/category/674/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 1250,
    dimensions: 'mm 251x83x79 h',
    id: 351,
    title: 'ACANTO',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/log-mini-log/acanto-ke067.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 8,
    cavityVolume: 50,
    dimensions: '114 x 39 x h 20 mm',
    id: 352,
    title: 'Slake PX3214S',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/single-serving-mignon/slake-px3214s.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 12,
    cavityVolume: 90,
    dimensions: '\u00d8 mm 68x34 h',
    id: 353,
    title: 'GNAMMY',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/single-serving-mignon/gnammy-px4372.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 848,
    dimensions: '',
    id: 354,
    title: 'LOUVRE',
    url: 'https://pavonitalia.com/professional/en/collezioni/pasticceria/torte/louvre-ke070.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 2250,
    dimensions: '',
    id: 355,
    title: 'ROUND FRT004',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/2743/s/round-frt004/category/677/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 12,
    cavityVolume: 90,
    dimensions: '',
    id: 356,
    title: 'Sfogliatella',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/single-serving-mignon/px4377s-sfogliatella.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 20,
    cavityVolume: 105,
    dimensions: '\u00d8 mm 57x63 h',
    id: 357,
    title: 'LOTUS',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/single-serving-mignon/lotus-px4371.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 960,
    dimensions: '\u00d8 mm 180x45 h',
    id: 358,
    title: 'La Vie en Rose KE080S',
    url: 'https://pavonitalia.com/professional/en/collezioni/pasticceria/torte/la-vie-en-rose-ke080s.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 8,
    cavityVolume: 38,
    dimensions: '\u00d8 62x21 h mm',
    id: 359,
    title: 'Mini Scarlet TOP23 - raspberry shape',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/single-serving-mignon/mini-scarlet-top23.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 1685,
    dimensions: '',
    id: 360,
    title: 'FRT103',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/2866/s/frt103/category/677/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 5,
    cavityVolume: 420,
    dimensions: '',
    id: 361,
    title: 'DADA PX4319',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/3164/s/dada-px4319/category/674/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 440,
    dimensions: '\u00d8 mm 180x26 h',
    id: 362,
    title: 'Scarlet TOP27 - raspberry shape',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/5754/s/scarlet-top27/category/675/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 24,
    cavityVolume: 33,
    dimensions: '',
    id: 363,
    title: 'SPHERE PX4315',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/3148/s/sphere-px4315/category/676/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 20,
    cavityVolume: 65,
    dimensions: '',
    id: 364,
    title: 'SPHERE PX4316',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/3149/s/sphere-px4316/category/676/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 1240,
    dimensions: 'mm 250x88x73 h',
    id: 365,
    title: 'Skyline',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/log-mini-log/ke073s-skyline.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 24,
    cavityVolume: 5,
    dimensions: '',
    id: 366,
    title: 'FR116 FLORENTINE',
    url: 'https://pavonitalia.com/professional/en/collezioni/pasticceria/formaflex/fr116-florentine.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 1230,
    dimensions: 'mm 250x83x90 h',
    id: 367,
    title: 'KE078S CHALET',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/log-mini-log/ke078s-chalet.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 20,
    cavityVolume: 65,
    dimensions: '',
    id: 368,
    title: 'PX4358S NOISETTE',
    url: 'https://pavonitalia.com/professional/en/collezioni/pasticceria/sphere/px4358s-noisette.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 870,
    dimensions: '',
    id: 369,
    title: 'TONDA KE997',
    url: 'https://pavonitalia.com/professional/en/collezioni/pasticceria/formaflex/tonda-ke997.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 285,
    dimensions: '\u00d8 mm 140x33 h',
    id: 370,
    title: 'Frisbee',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/5664/s/top17-frisbee/category/675/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 5,
    cavityVolume: 360,
    dimensions: '',
    id: 371,
    title: 'SOFT PX4310',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/3167/s/soft-px4310/category/674/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 1600,
    dimensions: '',
    id: 372,
    title: 'FLUTED CAKE MOULD FRT052',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/2857/s/fluted-cake-mold-frt052/category/677/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 20,
    cavityVolume: 65,
    dimensions: '',
    id: 373,
    title: 'PX4359S CITRON',
    url: 'https://pavonitalia.com/professional/en/collezioni/pasticceria/sphere/px4359s-citron.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 8,
    cavityVolume: 82,
    dimensions: '',
    id: 374,
    title: 'AF008S NOISETTE',
    url: 'https://pavonitalia.com/professional/en/collezioni/pasticceria/sphere/af008s-noisette.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 267,
    dimensions: '\u00d8 mm 180x18 h',
    id: 375,
    title: 'Hazel TOP25 - hazelnut shape',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/5752/s/hazel-top25/category/675/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 48,
    cavityVolume: 4,
    dimensions: '',
    id: 376,
    title: 'SPHERE PX4314',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/3146/s/sphere-px4314/category/676/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 1260,
    dimensions: 'mm 250x80x75 h',
    id: 377,
    title: 'KE079S Xmas',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/log-mini-log/ke079s-xmas.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 8,
    cavityVolume: 48,
    dimensions: '\u00d8 mm 60x28 h',
    id: 378,
    title: 'Frisbee',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/single-serving-mignon/px3208s-frisbee.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 1065,
    dimensions: 'mm 250x97x95 h',
    id: 379,
    title: 'KE077S FOREST',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/log-mini-log/ke077s-forest.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 295,
    dimensions: '\u00d8 mm 180x17 h',
    id: 380,
    title: 'Almonds TOP26 - almond shape',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/5753/s/walnut-top26/category/675/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 8,
    cavityVolume: 85,
    dimensions: '',
    id: 381,
    title: 'AF006S CITRON',
    url: 'https://pavonitalia.com/professional/en/collezioni/pasticceria/sphere/af006s-citron.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 1230,
    dimensions: 'mm 250x88x73 h',
    id: 382,
    title: 'Comet',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/log-mini-log/ke072s-comet.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 1186,
    dimensions: 'mm 250x92x74 h',
    id: 383,
    title: 'SEQUOIA',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/log-mini-log/sequoia-ke066.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 2600,
    dimensions: '',
    id: 384,
    title: 'FRT005',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/2855/s/frt005/category/677/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 10,
    cavityVolume: 40,
    dimensions: 'mm 117x24,5x19,5 h',
    id: 385,
    title: 'Pill',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/single-serving-mignon/px3211s-pill.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 572,
    dimensions: '\u00d8 mm 180x40 h',
    id: 386,
    title: 'Frisbee',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/5666/s/top19s-frisbee/category/675/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 1385,
    dimensions: '240 X 105 mm - h 65 mm',
    id: 387,
    title: 'PLUMCAKE  FRT106',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/2868/s/plumcake-frt106/category/677/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 2750,
    dimensions: '',
    id: 388,
    title: 'GUGELHUPF  FRT104',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/2867/s/gugelhupf-frt104/category/677/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 1000,
    dimensions: '\u00d8\u00a0180 x h 56 mm',
    id: 389,
    title: 'Fa\u00e7on Saint-Honor\u00e9 KE074S',
    url: 'https://pavonitalia.com/professional/en/collezioni/pasticceria/torte/facon-saint-honore-ke074s.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 848,
    dimensions: '',
    id: 390,
    title: 'COROLLA',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/5587/s/corolla-ke070/category/675/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 12,
    cavityVolume: 100,
    dimensions: '\u00d8 mm 78x26 h',
    id: 391,
    title: 'La Vie en Rose PX4386S',
    url: 'https://pavonitalia.com/professional/en/collezioni/pastry/single-serving-mignon/la-vie-en-rose-px4386s.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 1660,
    dimensions: '280X105 mm - h 65 mm',
    id: 392,
    title: 'PLUMCAKE FRT120',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/2870/s/plumcake-frt120/category/677/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 8,
    cavityVolume: 48,
    dimensions: '\u00d8 mm 60x28 h',
    id: 393,
    title: 'Frisbee',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/5660/s/px3208s-frisbee/category/679/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 8,
    cavityVolume: 46,
    dimensions: '',
    id: 394,
    title: 'Charm',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/5661/s/px3209s-charm/category/679/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 8,
    cavityVolume: 49.5,
    dimensions: '\u00d8 mm 60x32 h',
    id: 395,
    title: 'Step',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/5662/s/px3210s-step/category/679/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 10,
    cavityVolume: 40,
    dimensions: 'mm 117x24,5x19,5 h',
    id: 396,
    title: 'Pill',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/5663/s/px3211s-pill/category/679/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 8,
    cavityVolume: 48,
    dimensions: '',
    id: 397,
    title: 'PX3200 ROUND',
    url: 'https://pavonitalia.com/professional/en/collezioni/pasticceria/progetto-crostate/px3200-round.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 15,
    cavityVolume: 90,
    dimensions: '',
    id: 398,
    title: 'PX4363 LOVELY',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/4627/s/px4363-lovely/category/679/',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 285,
    dimensions: '\u00d8 mm 140x33 h',
    id: 399,
    title: 'Frisbee',
    url: 'https://pavonitalia.com/professional/en/collezioni/pasticceria/progetto-crostate/top17-frisbee.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 414,
    dimensions: '\u00d8 mm 160x37 h',
    id: 400,
    title: 'Frisbee',
    url: 'https://pavonitalia.com/professional/en/collezioni/pasticceria/progetto-crostate/top18s-frisbee.html',
  },
  {
    brand: 'Pavoni',
    cavityCount: 1,
    cavityVolume: 572,
    dimensions: '\u00d8 mm 180x40 h',
    id: 401,
    title: 'Frisbee',
    url: 'https://pavonitalia.com/professional/en/catalog/product/view/id/5666/s/top19s-frisbee/category/679/',
  },
];
